import axios from "axios"

export default {
  getBusinesses() {
    const url = "fam/businesses"

    return axios.get(url).then(resposnse => {
      return resposnse.data
    })
  },

  getAdAccounts(businessId) {
    const url = `fam/businesses/${businessId}/adaccounts`

    return axios.get(url).then(resposnse => {
      return resposnse.data
    })
  },
}
